<template>
  <SoPageWithHeader title="Edit User">
    <AdminUserEditForm>
      <template #form-action>
        <UserDelete />
      </template>
      <template #referral-code>
        <UserReferralCodeForm />
      </template>
      <template #cancellations>
        <UserCancellationsListTable />
      </template>
      <template #renewals>
        <UserRenewalsListTable />
      </template>
    </AdminUserEditForm>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import { defineComponent } from "vue"
  import AdminUserEditForm from "@/views/admin/users/components/AdminUserEditForm.vue"
  import UserDelete from "@/views/admin/users/components/UserDelete.vue"
  import UserReferralCodeForm from "@/views/admin/users/components/UserReferralCodeForm.vue"
  import UserCancellationsListTable from "@/views/admin/users/components/UserCancellationsListTable.vue"
  import UserRenewalsListTable from "@/views/admin/users/components/UserRenewalsListTable.vue"
  export default defineComponent({
    components: {
      UserReferralCodeForm,
      UserDelete,
      AdminUserEditForm,
      SoPageWithHeader,
      UserCancellationsListTable,
      UserRenewalsListTable,
    },
  })
</script>
